import { useState } from 'react'
import MainTopBar from '@/components/common/bar/MainTopBar'
import WideButton from '@/components/common/button/WideButton'
import type { PerformanceType } from '@/api/model/typeTestType'

interface PerformanceEvaluationProps {
  onComplete: (performance: PerformanceType) => void
  onBack: () => void
}

export default function PerformanceEvaluation({ onComplete, onBack }: PerformanceEvaluationProps) {
  const [selectedPerformance, setSelectedPerformance] = useState<PerformanceType | null>(null)

  const performanceOptions: { label: string; value: PerformanceType }[] = [
    { label: '매우 그렇다', value: '상' },
    { label: '조금 그렇다', value: '중상' },
    { label: '보통이다', value: '중' },
    { label: '전혀 아니다', value: '하' }
  ]

  const handleComplete = () => {
    if (selectedPerformance) {
      onComplete(selectedPerformance)
    }
  }

  return (
    <div className='min-h-screen'>
      <MainTopBar
        hasBackButton={true}
        leftSide={
          <div className='flex items-center gap-2'>
            <h1 className='text-header-title font-semibold text-text-header'>타입검사</h1>
          </div>
        }
        handleClickBackButton={onBack}
      />

      <div className='px-3 pb-8 pt-3'>
        <div className='bg-white rounded-2xl shadow-lg overflow-hidden min-h-[calc(100vh-200px)]'>
          <div className='p-6'>
            <div className='mb-12'>
              <h1 className='text-[20px] font-bold text-gray-800 leading-relaxed'>
                객관적으로 보았을 때, 나는 다른 친구들보다 공부를 잘하는 편이다.
              </h1>
            </div>

            <div className='space-y-3'>
              {performanceOptions.map(option => (
                <button
                  key={option.value}
                  onClick={() => setSelectedPerformance(option.value)}
                  className={`w-full py-4 px-6 rounded-2xl text-base font-medium transition-all duration-200 border-2 ${
                    selectedPerformance === option.value
                      ? 'bg-blue-50 border-blue-500 text-blue-600'
                      : 'bg-white border-gray-200 text-gray-700 hover:border-gray-300'
                  }`}
                >
                  {option.label}
                </button>
              ))}
            </div>
          </div>
        </div>

        <div className='flex gap-3 mt-4'>
          <WideButton className='box-border' buttonText='이전' handleClick={onBack} isDisabled={false} />
          <WideButton
            className={`box-border ${!selectedPerformance ? 'opacity-50' : ''}`}
            buttonText='제출하기'
            handleClick={handleComplete}
            isDisabled={!selectedPerformance}
          />
        </div>
      </div>
    </div>
  )
}
